export default val => {
  const [provider, id] = val.split(":")
  return {
    provider,
    id
  }
}
